import { KdsTextField } from "@kazaar-platform/design-system";
import { useTranslate } from "@tolgee/react";
import { Controller, type FieldPath, useFormContext } from "react-hook-form";

import { type FeatureFlagFormInputs } from "../schema/featureFlagSchema";

export interface ReportingMetadataProps {
  indexOnForm: number;
}

const getReportingMetadataFieldPath = (
  indexOnForm: number
): FieldPath<FeatureFlagFormInputs> => {
  return `featureFlags.${indexOnForm}.metadata.url` as FieldPath<FeatureFlagFormInputs>;
};

export const ReportingMetadata = ({ indexOnForm }: ReportingMetadataProps) => {
  const { t } = useTranslate();
  const methods = useFormContext<FeatureFlagFormInputs>();

  return (
    <Controller<FeatureFlagFormInputs>
      name={getReportingMetadataFieldPath(indexOnForm)}
      control={methods.control}
      defaultValue=""
      render={({ field: { value, onChange }, fieldState: { error } }) => (
        <KdsTextField
          label={t("oms.featureFlags.REPORTING.metadata.title")}
          placeholder={t("oms.featureFlags.REPORTING.metadata.placeholder")}
          value={typeof value === "string" ? value : ""}
          onChange={onChange}
          hasError={!!error?.message}
          errorMessage={error?.message}
        />
      )}
    />
  );
};
